<template>
  <div class="ledger-page pb-5 pb-md-2">
    <div
      v-if="loading"
      class="text-center py-3"
    >
      <b-spinner variant="primary" />
    </div>
    <b-card
      v-else-if="warehouse"
      class="rounded-lg"
    >
      <div class="d-flex justify-content-between align-items-start flex-wrap">
        <div>
          <h3 class="mb-50">
            {{ warehouse.code }}
          </h3>
          <div>{{ warehouse.name }}</div>
        </div>
        <b-button
          v-if="hasPermission('edit warehouses')"
          size="sm"
          variant="outline-primary"
          class="rounded-pill"
          :to="{ name: 'ledger-warehouses-edit', params: { id: warehouse.id } }"
        >
          {{ $t('ledger_wh_edit') }}
        </b-button>
      </div>
      <b-row class="mt-1">
        <b-col
          v-for="field in detailFields"
          :key="field.label"
          :cols="field.cols || 6"
          :md="field.md || 3"
          class="mb-1"
        >
          <span class="text-muted d-block">{{ field.label }}</span>
          <span>{{ field.value }}</span>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BButton, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getWarehouse } from '@/api/accounting/warehouses'
import { oneFrom, apiErrorMessage } from '@/utils/ledger'

export default {
  name: 'WarehouseShow',
  components: {
    BCard, BButton, BRow, BCol, BSpinner,
  },
  data() {
    return {
      loading: false,
      warehouse: null,
    }
  },
  computed: {
    detailFields() {
      const warehouse = this.warehouse || {}
      return [
        { label: this.$t('ledger_wh_code'), value: this.shown(warehouse.code) },
        { label: this.$t('ledger_wh_name'), value: this.shown(warehouse.name) },
        { label: this.$t('ledger_wh_area'), value: this.shown(warehouse.area) },
        { label: this.$t('ledger_wh_in_use'), value: warehouse.in_use ? this.$t('ledger_yes') : this.$t('ledger_no') },
        { label: this.$t('ledger_wh_description'), value: this.shown(warehouse.description), cols: 12, md: 12 },
        { label: this.$t('ledger_wh_created_at'), value: this.dateText(warehouse.created_at) },
      ]
    },
  },
  watch: {
    '$route.params.id': 'load',
  },
  mounted() {
    this.load()
  },
  methods: {
    shown(value) {
      if (value === null || value === undefined || value === '') return '—'
      return value
    },
    dateText(value) {
      if (!value) return '—'
      return String(value).replace('T', ' ').replace(/\.\d+Z?$/, '').slice(0, 19)
    },
    async load() {
      this.loading = true
      try {
        this.warehouse = oneFrom(await getWarehouse(this.$route.params.id))
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: apiErrorMessage(error, this.$t('ledger_error')),
            icon: 'AlertCircleIcon',
            variant: error?.response?.status === 422 ? 'warning' : 'danger',
          },
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
